<template>
  <div class="editor">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="menubar">

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.bold() }"
            @click="commands.bold"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-bold"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.italic() }"
            @click="commands.italic"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-italic"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.strike() }"
            @click="commands.strike"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-strikethrough"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.underline() }"
            @click="commands.underline"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-underline"></i>
                              </span>

        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.code() }"
            @click="commands.code"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-code"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.paragraph() }"
            @click="commands.paragraph"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-paragraph"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.heading({ level: 1 }) }"
            @click="commands.heading({ level: 1 })"
        >
          <span class="richtextarea-button">H1</span>

        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.heading({ level: 2 }) }"
            @click="commands.heading({ level: 2 })"
        >
          <span class="richtextarea-button">H2</span>

        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.heading({ level: 3 }) }"
            @click="commands.heading({ level: 3 })"
        >
          <span class="richtextarea-button">H3</span>

        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.bullet_list() }"
            @click="commands.bullet_list"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-list-ul"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.ordered_list() }"
            @click="commands.ordered_list"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-list-ol"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.blockquote() }"
            @click="commands.blockquote"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-quote-right"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            :class="{ 'is-active': isActive.code_block() }"
            @click="commands.code_block"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-code"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            @click="commands.horizontal_rule"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-grip-lines"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            @click="commands.undo"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-undo"></i>
                              </span>
        </button>

        <button
            class="menubar__button"
            @click="commands.redo"
        >
                              <span class="richtextarea-button">
                                <i class="fa fa-redo"></i>
                              </span>

        </button>

      </div>
    </editor-menu-bar>
    <editor-content class="editor__content" :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'
export default {
  components: {
    EditorContent,
    EditorMenuBar
  },
  data() {
    return {
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        content: "test içeriği",
      }),
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>
<style>
.richtextarea-button{
  font-weight: 700;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  background: transparent;
  color: #8a8a8a;
  padding: .5rem .5rem;
  margin-right: 0.7rem;
  border-radius: 3px;
  cursor: pointer;
  border: 1px solid #e6e6e6;
}
.editor__content{
  border: 1px solid #e6e6e6;
  border-radius: 3px;
  margin-top: 5px;
}
.editor__content .ProseMirror{
  margin-left: 5px;
  height: 250px;
}
.editor__content ol, ul{
  margin-left: 20px;
}
</style>